<ng-template #templateRef>
    <form #editorForm="ngForm" name="editAccount" (ngSubmit)="save()" id="accountEditor">
        <h2 mat-dialog-title>{{Copy && Copy.Id ? 'Edit' : 'New'}} account</h2>
        <mat-dialog-content *ngIf="Copy">
            <div class="row">
                <div class="col-12">
                    <app-account-selector name="Account" [(ngModel)]="Copy.Account"></app-account-selector>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <app-division-selector name="Division" [(ngModel)]="Copy.Division"></app-division-selector>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>